<app-page-header [heading]="'Warehouse Stock Log Report'" [icon]="'fa-list'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="row">
    <div class="form-group col-lg-3">
      <label>From</label>
      <input (ngModelChange)="fromdate = $event" [max]="getToday()" [ngModel]="fromdate | date:'yyyy-MM-dd'"
             class="form-control " id="date" name="date" type="date">

    </div>
    <div class="form-group col-lg-3">
      <label>To</label>
      <input (ngModelChange)="todate = $event" [max]="getToday()" [ngModel]="todate | date:'yyyy-MM-dd'"
             class="form-control " id="todate" name="todate" type="date">
    </div>
    <div class="form-group col-lg-4">
      <label>Warehouse Name</label>
      <ngx-select-dropdown (change)="getWarehouse($event);listPurchaseReport();" [(ngModel)]="warehouse_data"
                           [config]="utils.dropConfig({displayKey: 'WAREHOUSE_NAME',placeholder: 'Select Warehouse',searchOnKey: 'WAREHOUSE_NAME'})"
                           [multiple]="false"
                           [options]="warehouse_options" class="form-control  select-dropdown"
                           name="warehouse"></ngx-select-dropdown>
    </div>
    <div class="form-group col-lg-4">
      <label>Item Name</label>
      <ngx-select-dropdown (change)="getItem($event);listPurchaseReport();" [(ngModel)]="item_data"
                           [config]="utils.dropConfig({displayKey: 'TRADE_NAME',placeholder: 'Select Item',searchOnKey: 'TRADE_NAME'})"
                           [multiple]="false"
                           [options]="item_options" class="form-control  select-dropdown"
                           name="item_id"></ngx-select-dropdown>
    </div>
    <div class="form-group col-lg-2">
      <label></label><br>
      <button (click)="listPurchaseReport();" class="btn btn-info btn-sm ng-star-inserted" type="button">&nbsp;Search&nbsp;</button>
    </div>
    <div class="clearfix"></div>
    <div class="form-group col-lg-8"></div>
    <div class="form-group col-lg-4 ">
      <div class="input-group ">
        <input [(ngModel)]="term" class="form-control" id="typeahead-http" name="search_text" placeholder=""
               style="height:31px" type="text">
        <div class="input-group-append">
                    <span class="input-group-text" style="height:31px;padding:7px">
                        <i class="fa fa-search"></i>
                    </span>
        </div>
      </div>
    </div>
    <div class="text-right col-lg-12 pull-right">
      <button (click)="exportAsXLSX()" *ngIf="(purchase_data_full | json) != '[]'"
              class="btn btn-info btn-sm ng-star-inserted" title="Export as XLSX">Export to XLSX&nbsp;<i
        class="fa fa-file-excel-o"></i></button>
    </div>
    <div class="clearfix"></div>
    <div class="clearfix"></div>

    <div *ngFor="let purchase of purchase_data; " class="md_name col-12">

      <table #table class="table tbl table-bordered" style="background-color: #f3f8fd">
        <tr>
          <td>

            <div class="md_name_txt" style="font-weight: 600;">
              {{ purchase.name }}
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <table class="table tbl table-bordered" style="background-color: #f3f8fd">
              <thead>
              <tr class="text-center">
                <th width="4%">Sl</th>
                <th width="20%">Transaction date and time</th>
                <th>Warehouse (From)</th>
                <th>Warehouse (To)</th>
                <th width="7%">Qty</th>

              </tr>
              <tr *ngIf="(purchase_data | json) == '[]'">
                <td class="text-center" colspan="7">No data to list</td>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let purchase of purchase.data| filter:term;let i=index">
                <td class="text-center">{{ i + 1 }}</td>
                <td class="text-center">{{ purchase.CREATED_ON | date:'dd-MM-yyyy h:mm a' }}</td>
                <td>{{ purchase.WAREHOUSE_NAME_FROM }}</td>
                <td>{{ purchase.WAREHOUSE_NAME_TO }}</td>
                <td class="text-center">{{ purchase.QUANTITY_MOVED }}</td>
              </tr>
              </tbody>
            </table>

          </td>
        </tr>
      </table>
    </div>

  </div>
</div>



